export default __webpack_public_path__ + "static/media/log_out_dark.c0286d17.svg";